import { render } from "./FinanceTab.vue?vue&type=template&id=196d9e97&scoped=true"
import script from "./FinanceTab.vue?vue&type=script&lang=js"
export * from "./FinanceTab.vue?vue&type=script&lang=js"

import "./FinanceTab.vue?vue&type=style&index=0&id=196d9e97&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196d9e97"]])

export default __exports__